module.exports = __webpack_public_path__ + "img/img0201.7d523ddc.png";